/* ELV Motors referral attribution. Copyright ELV Motors, Inc. */
/* 把推荐码写进 Cookie 和购物车属性。结账时 Shopify 会把购物车属性抄到订单上。 */
(function () {
  var CODE = /^ELV-[A-Z0-9]{4,12}$/
  var DAYS = 30
  var MAX_AGE = DAYS * 24 * 60 * 60
  var KEYS = ['elv_ref', 'elv_ref_source', 'elv_ref_product', 'elv_ref_path', 'elv_ref_at']

  function readCookie(name) {
    var parts = document.cookie ? document.cookie.split('; ') : []
    for (var i = 0; i < parts.length; i += 1) {
      var pair = parts[i].split('=')
      if (pair[0] === name) return decodeURIComponent(pair.slice(1).join('='))
    }
    return ''
  }

  function writeCookie(name, value, maxAge) {
    document.cookie = name + '=' + encodeURIComponent(value) + '; Max-Age=' + maxAge + '; Path=/; SameSite=Lax'
  }

  function clearCookie(name) {
    document.cookie = name + '=; Max-Age=0; Path=/; SameSite=Lax'
  }

  function normalize(raw) {
    var code = String(raw || '').trim().toUpperCase()
    return CODE.test(code) ? code : ''
  }

  function page() {
    return window.ELV_REF_PAGE || { handle: '', path: window.location.pathname }
  }

  function readMeta() {
    try {
      return JSON.parse(readCookie('elv_ref_meta') || '{}')
    } catch (error) {
      return {}
    }
  }

  function fresh(at) {
    var time = Date.parse(at || '')
    if (!time) return false
    return Date.now() - time <= DAYS * 24 * 60 * 60 * 1000
  }

  function save(code, source) {
    var info = page()
    var meta = {
      source: source || 'link',
      product: info.handle || '',
      path: info.path || window.location.pathname,
      at: new Date().toISOString(),
    }
    writeCookie('elv_ref', code, MAX_AGE)
    writeCookie('elv_ref_meta', JSON.stringify(meta), MAX_AGE)
    return meta
  }

  function clearSaved() {
    clearCookie('elv_ref')
    clearCookie('elv_ref_meta')
  }

  function attributesFrom(code, meta) {
    return {
      elv_ref: code,
      elv_ref_source: meta.source || 'link',
      elv_ref_product: meta.product || '',
      elv_ref_path: meta.path || '',
      elv_ref_at: meta.at || '',
    }
  }

  function emptyAttributes() {
    var out = {}
    KEYS.forEach(function (key) { out[key] = '' })
    return out
  }

  function same(current, next) {
    return KEYS.every(function (key) {
      return String((current && current[key]) || '') === String(next[key] || '')
    })
  }

  function updateCart(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes }),
    }).then(function (response) {
      if (!response.ok) throw new Error('cart')
      return response.json()
    })
  }

  function syncCart() {
    var code = normalize(readCookie('elv_ref'))
    var meta = readMeta()
    if (!code || !fresh(meta.at)) {
      clearSaved()
      code = ''
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json() })
      .then(function (cart) {
        var next = code ? attributesFrom(code, meta) : emptyAttributes()
        if (same(cart.attributes, next)) return cart
        if (!code && !cart.attributes.elv_ref) return cart
        return updateCart(next)
      })
  }

  function refBox(root) {
    return root && root.querySelector ? root : document
  }

  function applyInput(raw, root) {
    var code = normalize(raw)
    var scope = refBox(root)
    var box = scope.querySelector('[data-elv-ref-message]') || document.getElementById('elv-ref-message')
    if (!code) {
      if (box) box.textContent = 'Enter a code like ELV-A123.'
      return
    }
    var meta = save(code, 'cart')
    updateCart(attributesFrom(code, meta)).then(function () {
      if (box) box.textContent = 'Referral code ' + code + ' applied.'
      var inputs = document.querySelectorAll('[data-elv-ref-input], #elv-ref-input')
      for (var i = 0; i < inputs.length; i += 1) inputs[i].value = code
      refreshDiscount()
    }).catch(function () {
      if (box) box.textContent = 'Could not save the referral code. Try again.'
    })
  }

  var params = new URLSearchParams(window.location.search)
  var incoming = normalize(params.get('ref'))
  if (incoming) {
    var source = String(params.get('ref_source') || '').toLowerCase() === 'qr' ? 'qr' : 'link'
    save(incoming, source)
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-elv-ref-apply]') : null
    if (!button) return
    event.preventDefault()
    var wrap = button.closest('[data-elv-ref]') || document
    var input = wrap.querySelector('[data-elv-ref-input], #elv-ref-input')
    applyInput(input ? input.value : '', wrap)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootDiscount)
  } else {
    bootDiscount()
  }

  var current = normalize(readCookie('elv_ref'))
  var APP_ACCOUNT = 'https://order.elvmotors.com/account/affiliate'

  function accountUrl(product) {
    var code = normalize(readCookie('elv_ref'))
    var meta = readMeta()
    var params = new URLSearchParams()
    if (product) params.set('product', product)
    if (code && fresh(meta.at)) {
      params.set('ref', code)
      params.set('ref_at', meta.at || '')
    }
    var query = params.toString()
    return query ? APP_ACCOUNT + '?' + query : APP_ACCOUNT
  }

  function paintAccountLinks() {
    var links = document.querySelectorAll('[data-elv-account]')
    for (var i = 0; i < links.length; i += 1) {
      links[i].setAttribute('href', accountUrl(links[i].getAttribute('data-elv-product') || ''))
    }
  }

  function currentCode() {
    var code = normalize(readCookie('elv_ref'))
    var meta = readMeta()
    return code && fresh(meta.at) ? code : ''
  }

  function shareHref(href, code) {
    var raw = String(href || '')
    if (!raw || !code) return raw
    var match = raw.match(/([?&](?:url|u)=)([^&]*)/i)
    if (!match) return raw
    var page = match[2]
    try {
      page = decodeURIComponent(page)
    } catch (error) {
      return raw
    }
    var product
    try {
      product = new URL(page, 'https://www.wi8.com')
    } catch (error) {
      return raw
    }
    if (product.protocol !== 'http:' && product.protocol !== 'https:') return raw
    product.searchParams.set('ref', code)
    product.searchParams.delete('ref_at')
    var plain = product.origin + product.pathname + product.search + product.hash
    if (match[2] === plain) return raw
    return raw.slice(0, match.index + match[1].length) + plain + raw.slice(match.index + match[0].length)
  }

  function paintShareLinks() {
    var code = currentCode()
    if (!code) return
    var links = document.querySelectorAll('.social-share a')
    for (var i = 0; i < links.length; i += 1) {
      links[i].setAttribute('href', shareHref(links[i].getAttribute('href') || '', code))
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('[data-elv-account]') : null
    if (!link) return
    link.setAttribute('href', accountUrl(link.getAttribute('data-elv-product') || ''))
  }, true)

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('.social-share a') : null
    if (!link) return
    var code = currentCode()
    if (!code) return
    link.setAttribute('href', shareHref(link.getAttribute('href') || '', code))
  }, true)

  document.addEventListener('DOMContentLoaded', function () {
    var inputs = document.querySelectorAll('[data-elv-ref-input], #elv-ref-input')
    for (var i = 0; i < inputs.length; i += 1) {
      if (current && !inputs[i].value) inputs[i].value = current
    }
    paintAccountLinks()
    paintShareLinks()
  })
  if (document.readyState !== 'loading') {
    paintAccountLinks()
    paintShareLinks()
  }

  var ORDER_API = 'https://order.elvmotors.com'

  function holdToken() {
    var token = readCookie('elv_discount_hold')
    if (!token) {
      token = 'h' + Math.random().toString(36).slice(2) + Date.now().toString(36)
      writeCookie('elv_discount_hold', token, MAX_AGE)
    }
    return token
  }

  function releaseDiscount() {
    var token = readCookie('elv_discount_hold')
    clearCookie('elv_discount_code')
    if (!token) return Promise.resolve()
    clearCookie('elv_discount_hold')
    return fetch(ORDER_API + '/api/affiliate/discount-release', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ hold_token: token }),
    }).catch(function () {})
  }

  function claimDiscount() {
    var code = currentCode()
    var meta = readMeta()
    if (!code) return releaseDiscount().then(function () { return '' })
    var email = (window.ELV_REF_PAGE && window.ELV_REF_PAGE.email) || ''
    return fetch(ORDER_API + '/api/affiliate/discount-hold', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ref: code,
        ref_at: meta.at || '',
        hold_token: holdToken(),
        email: email,
      }),
    }).then(function (response) { return response.json() }).then(function (data) {
      var next = data && data.code ? String(data.code) : ''
      if (data && data.hold_token) writeCookie('elv_discount_hold', data.hold_token, MAX_AGE)
      if (next) writeCookie('elv_discount_code', next, MAX_AGE)
      else clearCookie('elv_discount_code')
      return next
    }).catch(function () { return '' })
  }

  function applyCartDiscount(code) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code || '' }),
    }).catch(function () {})
  }

  function refreshDiscount() {
    return claimDiscount().then(function (code) { return applyCartDiscount(code) })
  }

  function bootDiscount() {
    syncCart().catch(function () {}).then(refreshDiscount)
  }

  document.addEventListener('elv:cart-refreshed', function () {
    var code = currentCode()
    var inputs = document.querySelectorAll('[data-elv-ref-input], #elv-ref-input')
    for (var i = 0; i < inputs.length; i += 1) {
      if (code && !inputs[i].value) inputs[i].value = code
    }
  })

  function checkoutWithDiscount(form) {
    var discount = readCookie('elv_discount_code')
    var code = currentCode()
    if (!discount || !code) {
      window.location = '/checkout'
      return
    }
    var idInput = form && form.querySelector('[name="id"]')
    var qtyInput = form && form.querySelector('[name="quantity"]')
    var meta = readMeta()
    var add = idInput && idInput.value
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: idInput.value,
            quantity: qtyInput && qtyInput.value ? Number(qtyInput.value) : 1,
          }),
        })
      : Promise.resolve()
    add.then(function () {
      return updateCart(attributesFrom(code, meta))
    }).then(function () {
      window.location = '/discount/' + encodeURIComponent(discount) + '?redirect=/checkout'
    }).catch(function () {
      window.location = '/checkout'
    })
  }

  document.addEventListener('click', function (event) {
    var target = event.target && event.target.closest
      ? event.target.closest('.shopify-payment-button, button[name="checkout"], a[href="/checkout"], a[href$="/checkout"]')
      : null
    if (!target) return
    if (!readCookie('elv_discount_code') || !currentCode()) return
    event.preventDefault()
    event.stopPropagation()
    var form = target.closest ? target.closest('form') : null
    checkoutWithDiscount(form || document.querySelector('form[action*="/cart/add"]'))
  }, true)
})()
